// import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

interface InfoCardProps {
    count: number;
    content: string;
    title: string;
}

function InfoCard({ count, title, content }: InfoCardProps) {
    return (
        <Card id="section--background" className={`section--background section--info-card-${count} info__content-card`} >
            <Card.Body className='info__content-card-body'>
                <Card.Title className='info__content-card-body__title'>{title}</Card.Title>
                <Card.Text className='info__content-card-body__text'>
                    {content}
                </Card.Text>
                {/* <Button className='info__content-card-button' variant="primary">click me</Button> */}
            </Card.Body>
        </Card>
    );
}

export default InfoCard;